import React, { Component } from 'react'
import Swiper from 'react-slider-swiper'
import firebase from 'firebase'
import BubbleButton from '../BubbleButton/BubbleButton'
import './styles/ThirdSectionStyles.css'
import moment from 'moment'
// import Lines from '../Lines'

class ThirdSection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            slides: []
        }
    }

    componentDidMount() {

        const dbRef = firebase.database().ref('sections/ThirdSection')

        dbRef.on('value', this.setData.bind(this))
    }

    setData(snapshot) {
        const data = snapshot.val()

        if (data && data.slides) {
            let slides = []

            for (let key in data.slides) {
                if (data.slides[key].isVisible) {
                    slides.push(data.slides[key])
                }
            }

            this.setState({
                slides: slides
            })
        }
    }

    _renderSlide() {
        return this.state.slides.map((item, i) => {
            const now = moment().format('x')
            return (
                <div key={`TimeLineSlide${i}${now}`} className="ThirdSectionSlideWrapper">
                    <div className="ThirdSectionSlide">
                        <div className="ThirdSectionSlideLeft">
                            <div className="ThirdSectionSlideTitle">
                                <h2>{item.title}</h2>
                            </div>
                            <div className="ThirdSectionSlideDescription">
                                <p>{item.descr}</p>
                            </div>
                            <div className="ThirdSectionSlideButtonWrapper">
                                <BubbleButton title={'КОНСУЛЬТАЦИЯ'} type={'transparent'} appRootView={this.props.appRootView} />
                            </div>
                        </div>
                        <div style={{ backgroundImage: (item.image && item.image.length) ? `url("${item.image[0].url}")` : 'none' }} className="ThirdSectionSlideRight">

                        </div>
                    </div>
                </div>
            )
        })
    }

    render() {
        const now = moment().format('x')
        return (
            <div className="ThirdSection">
                <div className="ThirdSectionSlider">
                    <div className="ThirdSectionSliderInner">
                        {(this.state.slides.length > 0) ? (
                            <Swiper
                                key={`ThirdSwiper${now}`}
                                pagination={'.ThirdSliderDots'}
                                paginationClickable={true}
                                nextButton={'.SliderNextArrowThird'}
                                prevButton={'.SliderPrevArrowThird'}
                                spaceBetween={30}
                                slidesPerView={1}
                                loop={true}
                            >
                                {this._renderSlide()}
                            </Swiper>
                        ) : null}
                    </div>   
                </div>

                
                <div className="FakeFullLines ">
                    <div className="FakeFullLinesInner"></div>
                </div>

            </div>
        )
    }
}

export default ThirdSection


// WEBPACK FOOTER //
// ./src/Components/Sections/ThirdSection.js